<template>
  <div>
    <v-row align="center" justify="start">
      <v-col cols="12" sm="6" md="3" lg="2">
        <v-autocomplete
          v-model="firstName"
          :items="firstNames"
          item-text="firstName"
          label="First Name"
          outlined
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="2">
        <v-autocomplete
          v-model="lastName"
          :items="lastNames"
          item-text="lastName"
          label="Last Name"
          outlined
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="2">
        <v-switch
          class="my-auto"
          v-model="includeInactive"
          label="Include Inactive"
          @change="handleSearchClick"
        ></v-switch>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="12" sm="6">
        <FilterButtons
          @search="handleSearchClick"
          @clear="handleClearClick"
        ></FilterButtons>
      </v-col>
    </v-row>
    <FilterButtonsSmall
      @search="handleSearchClick"
      @clear="handleClearClick"
    ></FilterButtonsSmall>
  </div>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { FilterButtons, FilterButtonsSmall } from '@/components/buttons'

export default {
  components: {
    FilterButtons,
    FilterButtonsSmall
  },
  data () {
    return {
      yesNoList: [
        { name: 'Yes', value: true },
        { name: 'No', value: false }
      ]
    }
  },
  props: [
    'firstNames',
    'lastNames'
  ],
  computed: {
    ...mapFields('staffFilters', [
      'firstName',
      'lastName',
      'includeInactive'
    ])
  },
  methods: {
    ...mapActions('staffFilters', [
      'clearFilters'
    ]),
    handleSearchClick () {
      this.$emit('search')
    },
    handleClearClick () {
      this.clearFilters()
      this.$emit('clear')
    }
  }
}
</script>
